import React from 'react';
import {
  Box,
  Button,
  CircularProgress
} from '@mui/material';
import {
  Refresh as RefreshIcon,
  Calculate as CalculateIcon,
  PersonAdd as PersonAddIcon
} from '@mui/icons-material';

/**
 * StaffingActionButtons Component
 * 
 * Provides all the action buttons for staffing operations.
 * Extracted from StaffingStep for better maintainability.
 */
const StaffingActionButtons = ({
  onRefreshData,
  onRefreshMemberData,
  onApplyCola,
  onAddMember,
  onSave,
  loading = false,
  saving = false,
  refreshingRates = false,
  readOnly = false,
  hideButtons = false,
  localButtonStyle = {},
  secondaryButtonStyle = {}
}) => {
  if (hideButtons) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onRefreshData}
          disabled={loading || saving}
          sx={secondaryButtonStyle}
        >
          Refresh Data
        </Button>
        
        <Button
          variant="outlined"
          startIcon={refreshingRates ? <CircularProgress size={16} /> : <RefreshIcon />}
          onClick={onRefreshMemberData}
          disabled={loading || saving || refreshingRates}
          sx={secondaryButtonStyle}
          title="Refresh rates and role information for all assigned team members"
        >
          {refreshingRates ? 'Refreshing...' : 'Refresh Member Data'}
        </Button>
        
        <Button
          variant="outlined"
          startIcon={<CalculateIcon />}
          onClick={onApplyCola}
          disabled={loading || saving || refreshingRates}
          sx={secondaryButtonStyle}
          title="Apply timeline-based COLA adjustments to all roles"
        >
          Apply Timeline COLA
        </Button>
        
        <Button
          variant="outlined"
          startIcon={<PersonAddIcon />}
          onClick={onAddMember}
          disabled={readOnly}
          sx={secondaryButtonStyle}
        >
          Add Member
        </Button>
      </Box>
      
      <Button
        variant="contained"
        onClick={onSave}
        disabled={readOnly || saving}
        sx={localButtonStyle}
      >
        {saving ? 'Saving...' : 'Save Staffing Plan'}
      </Button>
    </Box>
  );
};

export default StaffingActionButtons;